<script setup>
import { defineProps, ref } from 'vue'
import { useRestoGLobalStore } from '@/stores/restoGlobalStore'
import { useCartGLobalStore } from '@/stores/cartGlobalStore'
import { addSimpleItemFn } from '@/services/api/restApiCalls'
import { notify } from 'notiwind'
import { CheckCircleIcon } from '@heroicons/vue/24/outline'

const restoStore = useRestoGLobalStore()
const cartStore = useCartGLobalStore()
const props = defineProps(['simpleItemData', 'productInfo', 'itemCount'])
const showSuccessEffect = ref(false)
const handleAddSimpleItem = async (simpleItem) => {
  if (cartStore.CART_DATA?.order_type == 'delivery' && !cartStore?.CART_DATA?.pc_data?.is_valid) {
    cartStore.SHOW_POSTCODE_MODAL = true
  } else {
    const simpleItemData = {
      action: 'add',
      resto_id: restoStore?.RESTO_ID,
      item_id: simpleItem.item_id
    }
    let simpleItemFormData = new FormData()
    simpleItemFormData.append('cart_data', JSON.stringify(simpleItemData))
    const cart_info = await addSimpleItemFn(simpleItemFormData)
    cartStore.CART_DATA = cart_info[restoStore?.RESTO_ID]
    cartStore.CAN_DO_CHECKOUT = cart_info?.can_do_checkout
    restoStore.hideModal()
    showSuccessEffect.value = true
    setTimeout(() => {
      showSuccessEffect.value = false
    }, 1200)
    notify(
      {
        group: 'success',
        title: 'Added',
        text: `${simpleItem?.item_name} added to cart`
      },
      2000
    )
  }
}
</script>

<template>
  <div
    v-if="simpleItemData?.menu_img_url"
    class="flex items-center rounded-lg border border-gray-300 dark:border-gray-700 p-3 cursor-pointer hover:border-indigo-400 hover:shadow-md dark:hover:border-indigo-500 bg-white dark:bg-surface-dark transition-all duration-200 transform hover:scale-[1.01]"
    @click="simpleItemData?.is_available == 0 ? null : handleAddSimpleItem(simpleItemData)"
  >
    <div class="min-w-0 flex-1">
      <h3 as="h3" class="text-md font-semibold leading-6 text-gray-900 dark:text-text-dark">
        {{ simpleItemData?.item_name_full }}
      </h3>
      <div v-if="itemCount == 1 && productInfo">
        <p class="line-clamp-2 text-sm text-gray-500 dark:text-gray-400 mt-1 mb-1">{{ productInfo }}</p>
      </div>
      <div class="mt-1 text-base font-medium text-gray-900 dark:text-text-dark">
        <span class="text-indigo-600 dark:text-indigo-400"> £{{ simpleItemData?.price }} </span>
      </div>
    </div>
    <div v-if="simpleItemData?.menu_img_url" class="flex-shrink-0 ml-3">
      <div
        class="h-16 w-16 rounded-md overflow-hidden shadow-sm"
        :style="{
          backgroundImage: 'url(' + simpleItemData?.menu_img_url + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }"
      ></div>
    </div>
    <div v-if="simpleItemData?.is_available == 0" class="absolute -top-2.5 left-0">
      <span class="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800">Unavailable</span>
    </div>
    <div
      v-if="showSuccessEffect"
      class="absolute inset-0 bg-green-100/95 rounded-xl flex items-center justify-center z-20 backdrop-blur-sm"
    >
      <div class="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-full shadow-lg animate-pulse">
        <CheckCircleIcon class="h-5 w-5 text-white" />
        <span class="font-medium text-sm">Added</span>
      </div>
    </div>
  </div>
  <div
    v-else
    class="rounded-lg border border-gray-300 dark:border-gray-700 p-3 cursor-pointer hover:border-indigo-400 hover:shadow-md dark:hover:border-indigo-500 bg-white dark:bg-surface-dark transition-all duration-200 transform hover:scale-[1.01]"
    @click="simpleItemData?.is_available == 0 ? null : handleAddSimpleItem(simpleItemData)"
  >
    <div class="flex justify-between items-center">
      <h3 as="h3" class="text-md font-semibold leading-6 text-gray-900 dark:text-text-dark">
        {{ simpleItemData?.item_name_full }}
      </h3>
      <div class="ml-3 text-indigo-600 dark:text-indigo-400 font-medium">
        <span> £{{ simpleItemData?.price }} </span>
      </div>
    </div>
    <div v-if="itemCount == 1 && productInfo">
      <p class="line-clamp-2 text-sm text-gray-500 dark:text-gray-400 mt-1 mb-0">{{ productInfo }}</p>
    </div>
    <div v-if="simpleItemData?.is_available == 0" class="absolute -top-2.5 left-0">
      <span class="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800">Unavailable</span>
    </div>
    <div
      v-if="showSuccessEffect"
      class="absolute inset-0 bg-green-100/95 rounded-xl flex items-center justify-center z-20 backdrop-blur-sm"
    >
      <div class="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-full shadow-lg animate-pulse">
        <CheckCircleIcon class="h-5 w-5 text-white" />
        <span class="font-medium text-sm">Added</span>
      </div>
    </div>
  </div>
</template>
